import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
    component: RouteComponent,
    beforeLoad: ({ context }) => {
        throw redirect({
            to: context.auth.status === 'authed' ? '/home' : '/sign-in',
        })
    }
})

function RouteComponent() {
    return <></>
}